import { render, staticRenderFns } from "./SwitchListItem.vue?vue&type=template&id=bcf09cea&scoped=true&"
import script from "./SwitchListItem.vue?vue&type=script&lang=js&"
export * from "./SwitchListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf09cea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VListItemAction,VSwitch})
